import React from 'react'
import SuperyProductsContainer from '../../../../Components/ProductRegisterPart/SuperyProductsContainer/SuperyProductsContainer'
import Layout from '../../Layout'

const SuperyProducts = () => {
  return (
    <Layout>
        <SuperyProductsContainer/>
    </Layout>
  )
}

export default SuperyProducts